/*
     Title: external-process API
     Description: external-process API
     Author: Iqbal Hossain
     Date: 18-January-2022
     Modified: 18-January-2022
*/

export const EXTERNAL_PROCESS_API = {
  root: '/api/external-process',
  fetch_all: 'api/external-process/fetch-all',
  fetch_by_query: `/api/external-process/fetch-by-query`,
  fetch_by_id: `/api/external-process/fetch-by-id`,
  get_by_range: `/api/external-process/get-range`
};
